import qs from 'qs';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

export function useExpiredSessionUrl(): string {
	const {
		data: {
			petition: { slug },
		},
	} = usePetitionDetailsPageData();

	return `/p/${slug}?${qs.stringify({ show_sign: true, expired_session: true })}`;
}
